import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MessageBoxProvider } from './components/MessageBoxContainer';
import Header from './components/Header';
import Hero from './components/Hero';
import InfoBoxes from './components/InfoBoxes';
import Candidates from './components/Candidates';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import HelpButton from './components/HelpButton';
import VotingPage from './pages/VotingPage';
import AdminPanel from './pages/AdminPanel';
import ResultsPage from './pages/ResultsPage';

function HomePage() {
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleAnchorClick = (e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80, // Adjust for header height
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Candidates />
      <InfoBoxes />
      <Testimonials />
      <Contact />
      <Footer />
      <HelpButton />
    </>
  );
}

function App() {
  return (
    <MessageBoxProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/voting" element={<VotingPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/results" element={<ResultsPage />} />
          </Routes>
        </div>
      </Router>
    </MessageBoxProvider>
  );
}

export default App;